import { SearchResponseItem } from './suggestions-response-item';

export interface GetSuggestionsResponse {
  suggestionType: string;
  count: number;
  prefix?: string;
  prefixType: string;
  searches: SearchResponseItem[];
}
